<template>
  <div
    role="button"
    class="flex items-center w-full p-0 leading-tight transition-all rounded-lg outline-none text-start hover:bg-main-50 dark:hover:bg-gray-700 hover:bg-opacity-80 hover:text-main-900 dark:hover:text-gray-100 focus:bg-main-50 dark:focus:bg-gray-700 focus:bg-opacity-80 focus:text-main-900 dark:focus:text-gray-100 active:bg-main-50 dark:active:bg-gray-700 active:bg-opacity-80 active:text-main-900 dark:active:text-gray-100"
  >
    <button
      type="button"
      class="flex items-center justify-between w-full p-3 text-xl antialiased font-semibold leading-snug text-left transition-colors border-b-0 select-none border-b-main-100 text-main-700 dark:text-gray-300 hover:text-main-900 dark:hover:text-gray-100"
    >
      <!-- Dashboard Icon -->
      <div class="grid mr-4 place-items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          aria-hidden="true"
          class="w-5 h-5"
        >
          <path
            fill-rule="evenodd"
            d="M2.25 2.25a.75.75 0 000 1.5H3v10.5a3 3 0 003 3h1.21l-1.172 3.513a.75.75 0 001.424.474l.329-.987h8.418l.33.987a.75.75 0 001.422-.474l-1.17-3.513H18a3 3 0 003-3V3.75h.75a.75.75 0 000-1.5H2.25zm6.04 16.5l.5-1.5h6.42l.5 1.5H8.29zm7.46-12a.75.75 0 00-1.5 0v6a.75.75 0 001.5 0v-6zm-3 2.25a.75.75 0 00-1.5 0v3.75a.75.75 0 001.5 0V9zm-3 2.25a.75.75 0 00-1.5 0v1.5a.75.75 0 001.5 0v-1.5z"
            clip-rule="evenodd"
          ></path>
        </svg>
      </div>

      <!-- Dashboard Text -->
      <p
        class="block mr-auto text-base antialiased font-normal leading-relaxed text-main-900 dark:text-gray-200"
      >
        Dashboard
      </p>

      <!-- Chevron Icon -->
      <i
        class="fa-solid fa-chevron-right text-[12px] ml-4 transition-transform duration-300"
      ></i>
    </button>
  </div>
</template>

<script>
export default {
  name: "DashboardNavComponent",
};
</script>
